const foldOut = document.querySelector("[data-js='foldOut']");

if (foldOut) {
  const foldOutInput = document.querySelector("#f-search-location");
  let foldOutEl = document.querySelector(".fold-out");
  let autoCompSearch = document.querySelector(".fold-out__autocomplete");

  foldOutInput.onblur = function () {
    this.placeholder = placeholderWhereTo;

    setTimeout(function () {
      foldOutEl.classList.remove("active");
    }, 300);
  };

  foldOutInput.onfocus = function () {
    this.placeholder = "";
    foldOutEl.classList.add("active");

    if (this.value.length >= 2) {
      autoCompSearch.classList.add("active");
    } else {
      autoCompSearch.classList.remove("active");
    }
  };

  foldOutInput.addEventListener("keyup", function (e) {
    $("#form-search-location").val(this.value);
    // Check if characters is over 3
    if (this.value.length >= 3) {
      //**** FEWO CLOUD ****
      $(".fold-out__autocomplete").empty();
      var url =
        "https://" +
        host +
        "/api.php?api=getAutocomplete&client=lagoreisen&q=" +
        $("#f-search-location").val();
      var data = {
        q: $("#f-search-location").val(),
        type: "getAutocomplete",
      };

      $.getJSON(url, data, function (data, status) {
        if (status === "success") {
          data.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
          $(".fold-out__autocomplete").empty();
          $(data).each(function (index, element) {
            var len = data.length;
            $(".fold-out__autocomplete").append(
              '<div class="fold-out-list-accommodation">\n ' +
                '<div class="acc-img">\n ' +
                (element.picture_preview
                  ? '<img class="img-fluid object-fit-contain" style="width:40;height:40;" src="https://cdn.fewo.cloud/lagoreisen/thumb/' +
                    element.picture_preview +
                    '">'
                  : " <div class='acc-img icon'><img class='img-fluid' src='/assets/img/svg/icon-location.svg' width='40' height='40'></div>") +
                "</div>\n " +
                '<div class="info">\n ' +
                '<a href="#" class="fold-out-search-location" alt="' +
                element.name +
                '" data-id="' +
                element.id +
                '">\n ' +
                '<h3 class="headline">' +
                element.name.substring(0, 40) +
                "</h3>\n " +
                "</a>\n " +
                "<p>" +
                (element.city ? element.city + ": " : "") +
                element.region +
                "</p>\n " +
                '<span class="info-badge">' +
                element.type +
                "</span>\n " +
                "</div>\n " +
                "</div>\n "
            );
            if (index < len - 1)
              $(".fold-out__autocomplete").append('<hr class="default">');

            $(".fold-out-search-location").click(function () {
              foldOutInput.value = $(this).attr("alt");
              $("#form-search-location").val($(this).attr("alt"));
              $("#f-search-location").val($(this).attr("alt"));
              let unit_id = $(this).data("id");
              let global_unit_id = $(this).data("id");
              console.log(unit_id);
            });
          });
        }
      });
      //**** FEWO CLOUD ****
      autoCompSearch.classList.add("active");
    } else {
      autoCompSearch.classList.remove("active");
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("form-search-block");
    const modal = document.getElementById("mobile-modal");
    const desktopContainer = document.getElementById("desktop-container");

    function moveFormToModal() {
      if (window.innerWidth < 768) {
        if (!modal.contains(form)) {
          modal.appendChild(form);
        }
      } else {
        if (!desktopContainer.contains(form)) {
          desktopContainer.appendChild(form);
        }
      }
    }

    moveFormToModal();

    window.addEventListener("resize", moveFormToModal);
  });
}
